<template>
  <v-menu absolute content-class="tw-top-14" max-height="600px" z-index="500">
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="notifications && !notifications.length"
        class="elevation-0 tw-h-10 tw-w-10 disabled:tw-opacity-50"
        icon
        v-on="on">
        <v-badge
          :content="
            notifications ? Object.keys(groupedNotifications).length : null
          "
          :value="notifications && notifications.length"
          bordered
          color="orange"
          offset-x="10"
          offset-y="10">
          <v-icon class="tw-cursor-pointer tw-text-ci-gray-300">
            mdi-bell
          </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list v-if="notifications && notifications.length" two-line width="400">
      <v-divider v-if="notifications"></v-divider>
      <template v-if="groupedNotifications.FINAPI">
        <v-list-item three-line @click="processNotification('FINAPI')">
          <v-list-item-content>
            <v-list-item-title>
              <b>{{ $t('notifications.finapi.title') }}</b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('notifications.finapi.sub-title') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="groupedNotifications.INVOICE">
        <v-list-item three-line @click="processNotification('INVOICE')">
          <v-list-item-content>
            <v-list-item-title>
              <b>{{ $t('notifications.invoice.title') }}</b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('notifications.invoice.sub-title') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="groupedNotifications.TRANSACTION">
        <v-list-item three-line @click="processNotification('TRANSACTION')">
          <v-list-item-content>
            <v-list-item-title>
              <b>{{ $t('notifications.transaction.title') }}</b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('notifications.transaction.sub-title') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="groupedNotifications.BANKING_ACCOUNT_CONNECTED">
        <v-list-item
          three-line
          @click="processNotification('BANKING_ACCOUNT_CONNECTED')">
          <v-list-item-content>
            <v-list-item-title>
              <b>{{ $t('notifications.banking_account_connected.title') }}</b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('notifications.banking_account_connected.sub-title') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="groupedNotifications.BANKING_ACCOUNT_CONNECT_ABORTED">
        <v-list-item
          three-line
          @click="processNotification('BANKING_ACCOUNT_CONNECT_ABORTED')">
          <v-list-item-content>
            <v-list-item-title>
              <b>
                {{ $t('notifications.banking_account_connect_aborted.title') }}
              </b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{
                $t('notifications.banking_account_connect_aborted.sub-title')
              }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-if="groupedNotifications.BANKING_ACCOUNT_CONNECT_FAILED">
        <v-list-item
          three-line
          @click="processNotification('BANKING_ACCOUNT_CONNECT_FAILED')">
          <v-list-item-content>
            <v-list-item-title>
              <b>
                {{ $t('notifications.banking_account_connect_failed.title') }}
              </b>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('notifications.banking_account_connect_failed.sub-title') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-list>
  </v-menu>
</template>
<script>
import MarkNotificationsAsReadMutation from '@/gql/mutations/markNotificationsAsRead.graphql'
import NotificationsQuery from '@/gql/queries/notifications.graphql'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      notifications: [],
    }
  },
  apollo: {
    notifications: {
      query: NotificationsQuery,
      skip() {
        return this.selectedNode === ''
      },
      variables() {
        return {
          node: this.selectedNode,
        }
      },
    },
  },
  computed: {
    ...mapGetters(['selectedNode']),
    groupedNotifications() {
      return this.notifications
        ? this.notifications.reduce((c, v) => {
            c[v.notification_type] = v
            return c
          }, {})
        : {}
    },
  },
  methods: {
    async processNotification(notificationType) {
      let urlTarget
      const params = {}

      switch (notificationType) {
        case 'FINAPI':
        case 'BANKING_ACCOUNT_CONNECT_FAILED':
        case 'BANKING_ACCOUNT_CONNECT_ABORTED':
          urlTarget = 'settings.payment_import'
          break
        case 'TRANSACTION':
          urlTarget = 'transactions'
          params['transaction_state'] = 'unassigned'
          break
        case 'INVOICE':
          urlTarget = 'invoices'
          params['state'] = 'overdue'
          break
      }

      await this.$apollo.mutate({
        mutation: MarkNotificationsAsReadMutation,
        variables: {
          type: notificationType,
          node: this.selectedNode,
        },
        update: (
          store,
          { data: { markNotificationsAsRead: notifications } },
        ) => {
          store.writeQuery({
            query: NotificationsQuery,
            variables: {
              node: this.selectedNode,
            },
            data: { notifications },
            overwrite: true,
          })
        },
      })

      if (!urlTarget) {
        return
      }

      const newRoute = this.$router.match({
        name: urlTarget,
        params: params,
      })

      if (this.$router.currentRoute.fullPath !== newRoute.fullPath) {
        await this.$router.push({
          name: urlTarget,
          params: params,
        })
      }
    },
  },
}
</script>
